module.exports = __webpack_public_path__ + "static/img/dszwh.1256cab7.png";